// extracted by mini-css-extract-plugin
export default {"main-frame":"main-frame_main-frame__a-WVR","children":"main-frame_children__QOoM1"};